import { RootStateOrAny, connect } from 'react-redux'

import { SubHeader } from './SubHeader'

export const SubHeaderContainer = connect((state: RootStateOrAny) => ({
  fromJoin: state.persist.get('simpleHeader', false),
}))(SubHeader)
